import { CSSProperties } from "@material-ui/styles";

type GeneralStyles = {
  img: CSSProperties;
  image: CSSProperties;
  form: CSSProperties;
  action: CSSProperties;
  actions: CSSProperties;
  table: CSSProperties;
  container: CSSProperties;
  general: {
    /**
     * @see {@link src/styles/common.ts:51}
     */
    borderRadius: number;
  } & CSSProperties;
};

export const GENERAL_STYLES: GeneralStyles = {
  img: {
    display: "block",
    maxWidth: "100%",
    maxHeight: "100%",
  },
  image: {
    width: 240,
    height: 240,
    marginBottom: 10,
  },
  form: {
    width: "100%",
  },
  action: {
    cursor: "pointer",
    visibility: "hidden",
    "&:last-child": {
      marginLeft: 10,
    },
  },
  actions: {
    marginTop: 50,
  },
  table: {
    minWidth: 650,
  },
  container: {
    "@media screen and (max-width: 959px)": {
      maxHeight: "calc(100vh - 280px)",
      minHeight: "300px",
    },
    maxHeight: "82vh",
  },
  general: {
    borderRadius: 12,
  },
};
